<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
         <div class="col-lg-3 mb-2">
            <button type="button" class="col-12 btn btn-danger waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                Ջնջել բոլոր ժամկետանց սևագրերը
            </button>
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
             <v-server-table
              ref="vtable"
              :url="`${proxyUrl}suggestions/get`"
              :options="options"
              :columns="columns"
            >
              <div slot="name" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.name}}
              </div>
              <div slot="code" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.code}}
              </div>
              <div slot="cpvs_count" class="d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.organize_rows.length}}
              </div>
              <div slot="cpvs_count" class="d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.organize_rows.length}}
              </div>
              <div slot="type" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.is_itender ? 'iTender մրցույթներ' : 'Պետական մեկ անձի մրցույթներ'}}
              </div>
              <div slot="winner_determining_type" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.winner_by_lots ? 'Ըստ չափաբաժինների' : 'Ըստ ընդհանուր գնի'}}
              </div>
              <div slot="customer" class="d-flex justify-content-center" slot-scope="{row}">
                {{row.client.name}}
              </div>
              <div slot="status" class="d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.status === 'finished' ? 'Ավարտված' : 'Ընթացիկ' }}
              </div>
              <div slot="end_date" class="d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.finish_date}}
              </div>
              <div slot="project" class="row justify-content-center" slot-scope="{row}">
                <template v-if="!row.organize.is_canceled">
                  <div class="col">
                    <button v-if="row.organize.status !== 'finished'" type="button" @click="() => {$modal.show('suggestion-modal', {...row, resetComponent}); setSuggestionSeen(row.id);}" data-toggle="modal" data-animation="bounce" class="w-100 btn btn-primary waves-effect waves-light mr-2 d-flex justify-content-center align-items-center">
                      Ներկայացնել գնային առաջարկը
                    </button>
                  </div>
                  <div v-if="row.organize.contract !== ''" class="col mt-2">
                    <button type="button" @click.stop="() => {$modal.show('contract-draft-modal', row); setSuggestionSeen(row.id);}" class="w-100 btn btn-primary waves-effect waves-light d-flex justify-content-center align-items-center" data-toggle="modal" data-animation="bounce">
                      <i class="fas fa-file-alt mr-1" /> Պայմանագրի նախագիծ
                    </button>
                  </div>
                </template>
                <template v-else>
                  Ընթացակարգը չեղարկվել է, քանի որ <b>{{row.organize.cancel_reason}}</b>
                </template>
              </div>
              <div slot="delete" class="d-flex justify-content-center"  slot-scope="{row}">
                <i @click.stop="deleteSuggestion(row.id)" class="mdi mdi-delete text-danger" style="font-size: 30px; cursor: pointer;"></i>
              </div>
            </v-server-table>
        </div>
        <suggestion-modal />
        <specification-modal />
        <contract-draft-modal />
        <row-specification-modal/>
      </div>
    </div>
  </div>
</template>

<script>
  import SuggestionModal from '../modals/SuggestionModal'
  import ContractDraftModal from '../modals/ContractDraftModal'
  import SpecificationModal from '@/components/modals/SpecificationModal'
  import RowSpecificationModal from '@/components/modals/RowSpecificationModal'

  export default {
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['name', 'code', 'cpvs_count', 'type', 'winner_determining_type', 'customer', 'status', 'end_date', 'project', 'delete'],
        options: {
          requestAdapter (data) {
            return {
              limit: data.limit ? data.limit : 5,
              page: data.page,
              responded: 0,
              is_signature: 1,
            }
          },
          responseAdapter({data}) {
            return { 
                data: data.data, 
                count: data.count
              }
          },
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          params:{ 
            component: this
          },
          sortable: [],
          // sortable: ['cpvs_count', 'code', 'type', 'customer', 'category', 'status', 'end_date'],
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns:['create_date','end_date'],
          dateFormat: "YYYY-mm-dd",
          headings: {
            cpvs_count: 'Չափաբաժինների քանակ',
            name: 'Ընթացակարգի անվանում',
            code: 'Ընթացակարգի ծածկագիր',
            type: 'Ընթացակարգի տեսակ',
            winner_determining_type: 'Հաղթողին որոշելու կարգը',
            customer: 'Պատվիրատու',
            category: 'Խումբ / Կատեգորիա',
            project: '',
            end_date: 'Վերջնաժամկետ',
            status: 'Կարգավիճակ',
            details: 'Մանրամասն',
            delete: '',
          },
          texts: {
            count:
            'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
          filterable: false
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: {SuggestionModal, SpecificationModal, ContractDraftModal, RowSpecificationModal},
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {
    },
    methods: {
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
      setSuggestionSeen(suggestionId) {
        this.$store.dispatch('suggestions/update', {id: suggestionId, data: { seen: true }}).then(async (response) => {
          this.$store.dispatch('user/me')
        })
      },
      deleteSuggestion(suggestionId) {
        this.$confirm(
          "Ջնջելուց հետո դուք այլևս չեք կարողանա վերականգնել առաջարկը", 
          "", 
          "warning", 
          {
            confirmButtonText: 'Շարունակել', 
            cancelButtonText: 'Փակել'
          }
        ).then(text => {
          this.$client.delete(`suggestions/${suggestionId}`).then(({data}) => {
            if(data.status){
              this.resetComponent();
            }
          })
        })
      }
    },
  }
</script>